export interface ICD10Diagnosis {
  code: string;
  name: string;
  category?: string;
}

const COMMON_DIAGNOSES: ICD10Diagnosis[] = [
  // Anxiety Disorders
  { code: 'F41.1', name: 'Generalized Anxiety Disorder', category: 'Anxiety' },
  { code: 'F41.0', name: 'Panic Disorder', category: 'Anxiety' },
  { code: 'F41.9', name: 'Anxiety Disorder, Unspecified', category: 'Anxiety' },
  { code: 'F40.10', name: 'Social Anxiety Disorder', category: 'Anxiety' },
  { code: 'F40.00', name: 'Agoraphobia', category: 'Anxiety' },
  { code: 'F40.210', name: 'Specific Phobia, Fear of Blood', category: 'Anxiety' },
  { code: 'F40.218', name: 'Specific Phobia, Other Medical Care', category: 'Anxiety' },
  { code: 'F40.230', name: 'Specific Phobia, Fear of Animals', category: 'Anxiety' },
  { code: 'F40.248', name: 'Specific Phobia, Other Natural Environment', category: 'Anxiety' },
  { code: 'F40.298', name: 'Specific Phobia, Other', category: 'Anxiety' },
  // Depressive Disorders
  { code: 'F32.0', name: 'Major Depressive Disorder, Single Episode, Mild', category: 'Depression' },
  { code: 'F32.1', name: 'Major Depressive Disorder, Single Episode, Moderate', category: 'Depression' },
  { code: 'F32.2', name: 'Major Depressive Disorder, Single Episode, Severe', category: 'Depression' },
  { code: 'F32.9', name: 'Major Depressive Disorder, Single Episode, Unspecified', category: 'Depression' },
  { code: 'F33.0', name: 'Major Depressive Disorder, Recurrent, Mild', category: 'Depression' },
  { code: 'F33.1', name: 'Major Depressive Disorder, Recurrent, Moderate', category: 'Depression' },
  { code: 'F33.2', name: 'Major Depressive Disorder, Recurrent, Severe', category: 'Depression' },
  { code: 'F33.9', name: 'Major Depressive Disorder, Recurrent, Unspecified', category: 'Depression' },
  { code: 'F34.1', name: 'Persistent Depressive Disorder (Dysthymia)', category: 'Depression' },
  { code: 'F34.81', name: 'Disruptive Mood Dysregulation Disorder', category: 'Depression' },
  // Bipolar Disorders
  { code: 'F31.0', name: 'Bipolar I, Current Episode Hypomanic', category: 'Bipolar' },
  { code: 'F31.11', name: 'Bipolar I, Current Episode Manic, Mild', category: 'Bipolar' },
  { code: 'F31.12', name: 'Bipolar I, Current Episode Manic, Moderate', category: 'Bipolar' },
  { code: 'F31.13', name: 'Bipolar I, Current Episode Manic, Severe', category: 'Bipolar' },
  { code: 'F31.31', name: 'Bipolar I, Current Episode Depressed, Mild', category: 'Bipolar' },
  { code: 'F31.32', name: 'Bipolar I, Current Episode Depressed, Moderate', category: 'Bipolar' },
  { code: 'F31.4', name: 'Bipolar I, Current Episode Depressed, Severe', category: 'Bipolar' },
  { code: 'F31.81', name: 'Bipolar II Disorder', category: 'Bipolar' },
  { code: 'F31.9', name: 'Bipolar Disorder, Unspecified', category: 'Bipolar' },
  { code: 'F34.0', name: 'Cyclothymic Disorder', category: 'Bipolar' },
  // Trauma & Stressor-Related
  { code: 'F43.10', name: 'Post-Traumatic Stress Disorder (PTSD)', category: 'Trauma' },
  { code: 'F43.0', name: 'Acute Stress Disorder', category: 'Trauma' },
  { code: 'F43.20', name: 'Adjustment Disorder, Unspecified', category: 'Trauma' },
  { code: 'F43.21', name: 'Adjustment Disorder with Depressed Mood', category: 'Trauma' },
  { code: 'F43.22', name: 'Adjustment Disorder with Anxiety', category: 'Trauma' },
  { code: 'F43.23', name: 'Adjustment Disorder with Mixed Anxiety and Depression', category: 'Trauma' },
  { code: 'F43.24', name: 'Adjustment Disorder with Disturbance of Conduct', category: 'Trauma' },
  { code: 'F43.25', name: 'Adjustment Disorder with Mixed Disturbance', category: 'Trauma' },
  // OCD & Related
  { code: 'F42.2', name: 'Obsessive-Compulsive Disorder (OCD)', category: 'OCD' },
  { code: 'F42.3', name: 'Hoarding Disorder', category: 'OCD' },
  { code: 'F45.22', name: 'Body Dysmorphic Disorder', category: 'OCD' },
  { code: 'F63.3', name: 'Trichotillomania (Hair-Pulling Disorder)', category: 'OCD' },
  { code: 'L98.1', name: 'Excoriation (Skin-Picking) Disorder', category: 'OCD' },
  // Personality Disorders
  { code: 'F60.3', name: 'Borderline Personality Disorder', category: 'Personality' },
  { code: 'F60.0', name: 'Paranoid Personality Disorder', category: 'Personality' },
  { code: 'F60.1', name: 'Schizoid Personality Disorder', category: 'Personality' },
  { code: 'F60.2', name: 'Antisocial Personality Disorder', category: 'Personality' },
  { code: 'F60.4', name: 'Histrionic Personality Disorder', category: 'Personality' },
  { code: 'F60.81', name: 'Narcissistic Personality Disorder', category: 'Personality' },
  { code: 'F60.5', name: 'Obsessive-Compulsive Personality Disorder', category: 'Personality' },
  { code: 'F60.6', name: 'Avoidant Personality Disorder', category: 'Personality' },
  { code: 'F60.7', name: 'Dependent Personality Disorder', category: 'Personality' },
  // ADHD
  { code: 'F90.0', name: 'ADHD, Predominantly Inattentive', category: 'ADHD' },
  { code: 'F90.1', name: 'ADHD, Predominantly Hyperactive-Impulsive', category: 'ADHD' },
  { code: 'F90.2', name: 'ADHD, Combined Type', category: 'ADHD' },
  { code: 'F90.9', name: 'ADHD, Unspecified', category: 'ADHD' },
  // Autism / Developmental
  { code: 'F84.0', name: 'Autism Spectrum Disorder', category: 'Developmental' },
  // Eating Disorders
  { code: 'F50.00', name: 'Anorexia Nervosa, Restricting Type', category: 'Eating' },
  { code: 'F50.02', name: 'Anorexia Nervosa, Binge-Eating/Purging Type', category: 'Eating' },
  { code: 'F50.2', name: 'Bulimia Nervosa', category: 'Eating' },
  { code: 'F50.81', name: 'Binge-Eating Disorder', category: 'Eating' },
  { code: 'F50.89', name: 'Other Specified Feeding or Eating Disorder', category: 'Eating' },
  // Substance Use
  { code: 'F10.10', name: 'Alcohol Use Disorder, Mild', category: 'Substance Use' },
  { code: 'F10.20', name: 'Alcohol Use Disorder, Moderate/Severe', category: 'Substance Use' },
  { code: 'F11.10', name: 'Opioid Use Disorder, Mild', category: 'Substance Use' },
  { code: 'F11.20', name: 'Opioid Use Disorder, Moderate/Severe', category: 'Substance Use' },
  { code: 'F12.10', name: 'Cannabis Use Disorder, Mild', category: 'Substance Use' },
  { code: 'F12.20', name: 'Cannabis Use Disorder, Moderate/Severe', category: 'Substance Use' },
  { code: 'F15.10', name: 'Stimulant Use Disorder, Mild', category: 'Substance Use' },
  { code: 'F15.20', name: 'Stimulant Use Disorder, Moderate/Severe', category: 'Substance Use' },
  { code: 'F13.10', name: 'Sedative/Hypnotic Use Disorder, Mild', category: 'Substance Use' },
  { code: 'F19.10', name: 'Other Substance Use Disorder, Mild', category: 'Substance Use' },
  // Sleep Disorders
  { code: 'F51.01', name: 'Primary Insomnia', category: 'Sleep' },
  { code: 'F51.11', name: 'Nightmare Disorder', category: 'Sleep' },
  // Somatic / Dissociative
  { code: 'F45.1', name: 'Somatic Symptom Disorder', category: 'Somatic' },
  { code: 'F44.81', name: 'Dissociative Identity Disorder', category: 'Dissociative' },
  { code: 'F44.0', name: 'Dissociative Amnesia', category: 'Dissociative' },
  { code: 'F48.1', name: 'Depersonalization/Derealization Disorder', category: 'Dissociative' },
  // Relationship / V-Codes (commonly used in couples/family)
  { code: 'Z63.0', name: 'Relationship Distress with Spouse/Partner', category: 'Relational' },
  { code: 'Z62.820', name: 'Parent-Child Relational Problem', category: 'Relational' },
  { code: 'Z65.8', name: 'Other Specified Problem Related to Psychosocial Circumstances', category: 'Relational' },
  { code: 'Z56.9', name: 'Occupational Problem', category: 'Relational' },
  { code: 'Z63.4', name: 'Uncomplicated Bereavement', category: 'Relational' },
];

export default COMMON_DIAGNOSES;
